import { IonButton, IonInput, IonItem, IonModal } from '@ionic/react';
import React, { Component } from 'react';
import { getConfig } from '../../appConfig.js';
import Basket from '../../lib/basket.js';
import { withTranslation } from '../../lib/translate.js';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../common/index.js';
import Modal from '../modal/index.js';
import './index.css';

class TableBillServiceCharge extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			service_charge: Basket.bill_pay_service_charge || 0,
			service_charge_applied: 0,
			billPayCustomServiceChargeModalOpen: false,
			custom_service_charge: 0,
			customAmountErrorVisible: false,
			serviceChargeUpdated: 0
		};
	}
	componentDidMount() {
		if (this.state.service_charge !== null) {
			Basket.setBillPayServiceCharge(this.state.service_charge);
		}
		this.props.serviceChargeSet(this.state.service_charge);
	}
	setBillPayCustomServiceCharge(value) {
		Basket.setBillPayServiceCharge(null, value * 100);
		this.setState(
			{
				custom_service_charge: value * 100,
				billPayCustomServiceChargeModalOpen: false,
				service_charge: null,
			},
			() => {
				this.props.serviceChargeSet(value * 100);
			},
		);
	}
	setCustomServiceChargeAmount = (value) => {
		if (value >= 0) {
			this.setState({ serviceChargeAmount: value, customAmountErrorVisible: false });
		} else {
			this.setState({ customAmountErrorVisible: true, serviceChargeAmount: 0 });
		}
	};
	setBillPayServiceCharge(e, service_charge) {
		e.stopPropagation();
		document.querySelectorAll('.bill-pay-service-charge-button').forEach((el) => el.classList.remove('is-active'));
		let applied_service_charge = 0
		if (Basket.bill_pay_service_charge == service_charge) {
			e.target.classList.remove('is-active');
			Basket.setBillPayServiceCharge(0);
			applied_service_charge = 0
		} else {
			e.target.classList.add('is-active');
			Basket.setBillPayServiceCharge(service_charge);
			applied_service_charge = service_charge

		}
		this.setState({ serviceChargeAmount:null,service_charge: applied_service_charge }, () => {
			this.props.serviceChargeSet(applied_service_charge);
		});
	}

	render() {
		const { __ } = this.props;
		return (
			<>
				<div className="service-charge-box-wrapper box-wrapper centered">
					<div className='service-charge-title' >
						<StrongText>{__('Optional service charge?')}</StrongText>
						<StrongText>{Basket.getBillPayServiceChargeValue()}</StrongText>
					</div>
					<div className='service-charge-values'>
						{getConfig().general.billPayServiceChargeValues.map((el, index) => {
							return (
								<IonButton
									key={index}
									className={` ${this.state.service_charge == el && 'is-active'}`}
									onClick={(e) => this.setBillPayServiceCharge(e, el)}
									color="secondary"
								>
									<NormalText>{el == 0 ? <>{__('None')}</> : <>{el}%</>}</NormalText>
								</IonButton>
							);
						})}
						<IonButton className={this.state.serviceChargeAmount && 'is-active'}
							expand="block" color='primary' onClick={(e) => this.setState({ billPayCustomServiceChargeModalOpen: true })}>
							<NormalText>{__('Custom')}</NormalText>
						</IonButton>
					</div>

				</div>
				{this.state.billPayCustomServiceChargeModalOpen && (
					<Modal
						className="modal-type-alert"
						onDidDismiss={() => this.setState({ billPayCustomServiceChargeModalOpen: false })}
						isOpen={this.state.billPayCustomServiceChargeModalOpen}
					>
						<StrongText className='block text-to-update'>{__('Add custom amount')}</StrongText>
						<Spacer size={5} />

						<IonItem lines="none" className="input-field-wrapper ">
							<NormalText className='input-field-floating-text label-color'>{Basket.getCurrency().label}</NormalText>

							<IonInput
								className="custom-amount-field"
								min="0"
								onIonInput={(e) => this.setCustomServiceChargeAmount(e.target.value)}
								type="number"
								pattern="number"
								inputmode="number"
							></IonInput>
						</IonItem>
						{this.state.customAmountErrorVisible && (
							<>
								<SmallText className="danger-color">{__('Value can not be negative')}</SmallText>
							</>
						)}
						<Spacer size={5} />


						<div className='alert-button-group'>
							<IonButton
								expand="block"
								color={'secondary'}
								onClick={() => this.setState({ billPayCustomServiceChargeModalOpen: false })}
							>
								{__('Cancel')}
							</IonButton>
							<IonButton
								disabled={!this.state.serviceChargeAmount || this.state.serviceChargeAmount == 0}
								color="primary"
								expand="block"
								onClick={() => this.setBillPayCustomServiceCharge(this.state.serviceChargeAmount)}
							>
								{__('Done')}
							</IonButton>
						</div>

					</Modal>
				)}
			</>
		);
	}
}

export default withTranslation(TableBillServiceCharge);
